// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_main_pages_pages_module_ts":"20c521850ad6cb3e","src_app_main_miscellaneous_miscellaneous_module_ts":"1329a11320992af7"}[chunkId] + ".js";
};